import React, { forwardRef } from "react";
import MuiButton from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { i18n } from "../../translate/i18n";
import { compactButtonLabel } from "./compactLabel";

const resolveLabel = (children, subject) => {
  const nodes = React.Children.toArray(children);
  const label = nodes.every(node => typeof node === "string" || typeof node === "number") ? nodes.join("") : null;
  const compact = compactButtonLabel(label, { subject, language: i18n.language });
  return compact ? { ...compact, original: label.trim() } : null;
};

// Keep the MUI button, native link/form props, handlers and refs intact.
const TabletButton = forwardRef(({ children, startIcon, tabletSubject, tabletStartIcon, ...props }, ref) => {
  const compact = resolveLabel(children, tabletSubject);
  if (!compact) return <MuiButton {...props} ref={ref} startIcon={startIcon}>{children}</MuiButton>;
  const accessible = compact.original.toLocaleLowerCase().includes(compact.text.toLocaleLowerCase())
    ? compact.original : `${compact.text}: ${compact.original}`;
  return <MuiButton {...props} ref={ref}
    startIcon={tabletStartIcon || (compact.create ? <AddIcon /> : startIcon)}
    aria-label={props["aria-label"] || accessible}
    data-full-label={compact.original}
    data-tablet-compact-label
  >{compact.text}</MuiButton>;
});
TabletButton.displayName = "TabletButton";

// Menu actions keep their existing menu item and icon arrangement.
export const TabletActionLabel = ({ children, tabletSubject, showCreateIcon = false }) => {
  const compact = resolveLabel(children, tabletSubject);
  if (!compact) return children;
  return <span aria-label={compact.original} style={showCreateIcon ? { display: "inline-flex", alignItems: "center", gap: 8 } : undefined}>
    {showCreateIcon && compact.create && <AddIcon fontSize="small" />}{compact.text}
  </span>;
};

export default TabletButton;
